import { render, staticRenderFns } from "./CheckboxField.vue?vue&type=template&id=ec802fb2&scoped=true"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"
import style0 from "./CheckboxField.vue?vue&type=style&index=0&id=ec802fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec802fb2",
  null
  
)

export default component.exports